export const BSAE_URL = "https://admin.aynajewels.in/amrut1api/";
